exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-title {\n    margin-bottom: 24px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/shane/workspace/website/website-client/src/app/banner/banner.component.css
// module id = ../../../../../src/app/banner/banner.component.css
// module chunks = main